import { VALUE_PROPS } from "@/lib/siteContent";

export const WhyCrownpath = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-24 sm:py-32 border-t border-[#E5E7EB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-6">
              Why Crownpath
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight leading-tight text-[#0F2A44]">
              Aligned with the
              <br />
              <span className="italic">people behind the wheel.</span>
            </h2>
            <p className="mt-8 text-[#1A1A1A]/75 leading-relaxed max-w-md">
              We built Crownpath the way we'd want a dispatcher to work with us —
              transparent, accountable, and on the same side of the table.
            </p>
          </div>

          <div className="lg:col-span-7">
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-12 gap-x-12">
              {VALUE_PROPS.map((v, idx) => (
                <div key={v.title} data-testid="value-prop">
                  <div className="flex items-baseline gap-3 mb-4">
                    <span className="text-xs tracking-[0.25em] text-[#D4AF7F]">
                      0{idx + 1}
                    </span>
                    <span className="h-px flex-1 bg-[#E5E7EB]" />
                  </div>
                  <dt className="font-serif text-xl sm:text-2xl text-[#0F2A44] mb-3 leading-snug">
                    {v.title}
                  </dt>
                  <dd className="text-[#1A1A1A]/75 leading-relaxed">
                    {v.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
};
